import React, { useEffect, useState } from "react";
import "../styles.css";
import { setVoiceWalkthrough } from "../../../Services/userSettings";
import { useNavigate } from "react-router-dom";

const VoiceHomeV2 = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(0); // 0 = welcome, 1..n tutorial steps, -1 = done
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Show tutorial only first time; auto-start session if already done
    try {
      const flag = localStorage.getItem("voice_walkthrough_done");
      if (flag === "true") {
        setStep(-1);
        setDismissed(true);
        // Resume audio if WebSocket is still alive, otherwise start new session
        if (window.resumeCoachingAudio) {
          console.log("🎤 Resuming existing audio session");
          window.resumeCoachingAudio();
        }
        navigate("/dialogues", { replace: true });
      } else {
        setTimeout(() => setStep(1), 400); // small delay like spec
      }
    } catch (_) {
      setTimeout(() => setStep(1), 400);
    }
  }, [navigate]);

  const finishTutorial = async () => {
    setStep(-1);
    setDismissed(true);
    try { localStorage.setItem("voice_walkthrough_done", "true"); } catch (_) {}
    try { await setVoiceWalkthrough(true); } catch (_) {}
    // auto-start voice session after finishing tutorial
    navigate("/dialogues", { replace: true });
  };

  const TutorialBubble = ({ title, desc }) => (
    <div className="tutv2-bubble">
      <div className="tutv2-title">{title}</div>
      <div className="tutv2-desc">{desc}</div>
      <div className="tutv2-controls">
        {step < 2 && (
          <button className="tutv2-next" onClick={() => setStep(step + 1)}>Next →</button>
        )}
        {step === 2 && (
          <button className="tutv2-next" onClick={finishTutorial}>Finish →</button>
        )}
      </div>
    </div>
  );

  const startVoiceSession = () => {
    // Reuse existing 1-1 experience
    navigate("/dialogues");
  };

  const dimClass = step > 0 ? "dim-others" : "";

  return (
    <div className="homev2-wrap">
      <div className={`homev2-voice ${dimClass}`}>
        <div className="homev2-orb" aria-hidden />
        <h2 className="homev2-title">Welcome to voice session</h2>

        <div className={`homev2-voice-controls ${step === 1 ? "spotlight" : ""}`}>
          <button className="homev2-mic" onClick={startVoiceSession} aria-label="Start voice session" />
          <div className="homev2-microcopy">Press & hold to speak</div>
        </div>

        <div className={`homev2-handsfree ${step === 2 ? "spotlight" : ""}`}>
          <div className="homev2-chip">Hands-free mode</div>
          <div className="homev2-chip">Default microphone</div>
        </div>

        {step === 1 && (
          <TutorialBubble
            title="Tutorial - Hands Free"
            desc="Use the hands-free mode when in quiet environments."
          />
        )}
        {step === 2 && (
          <TutorialBubble
            title="Tutorial - Default Microphone"
            desc="For noisy environments, use the default microphone."
          />
        )}
      </div>
      {dismissed && (
        <div className="homev2-actions">
          <button className="nav-continue" onClick={startVoiceSession}>Start session →</button>
        </div>
      )}
    </div>
  );
};

export default VoiceHomeV2;
